// Elm owns data decisions. Ports carry JSON facts; native adapters execute effects.
let worker,requestId=0;
const pending=new Map();
export function policy(operation,value){
  return new Promise((resolve,reject)=>{
    if(!worker){
      worker=window.Elm.Policy.init();
      worker.ports.policyResponse.subscribe(result=>{
        const request=pending.get(result.id);if(!request)return;
        pending.delete(result.id);
        if(result.error)request.reject(Error(result.error));else request.resolve(result.value);
      });
    }
    const id=++requestId;pending.set(id,{resolve,reject});
    queueMicrotask(()=>{try{worker.ports.policyRequest.send({id,operation,value});}catch(error){pending.delete(id);reject(error);}});
  });
}
